import { render } from "./LeaveRequestLoader.vue?vue&type=template&id=2d167f6a"
import script from "./LeaveRequestLoader.vue?vue&type=script&lang=js"
export * from "./LeaveRequestLoader.vue?vue&type=script&lang=js"

import "./LeaveRequestLoader.vue?vue&type=style&index=0&id=2d167f6a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__